/** @jsxImportSource @emotion/react */

import { useTheme } from "@mui/material";
import * as React from "react";

export function IdentityIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;

  return (
    <svg width={width} height={height} viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4 13v-.6a3 3 0 016 0v.6m1.8-8.4h3.6m-3.6 3.6h3.6M7 3.4A1.8 1.8 0 107 7a1.8 1.8 0 000-3.6zM2.8 1h14.4a1.2 1.2 0 011.2 1.2v9.6a1.2 1.2 0 01-1.2 1.2H2.8a1.2 1.2 0 01-1.2-1.2V2.2A1.2 1.2 0 012.8 1z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function QuestionMarkIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 9.579V8h.527c.872 0 1.579-.707 1.579-1.579v-.105c0-.814-.66-1.474-1.474-1.474H8c-.872 0-1.579.707-1.579 1.58m1.053 4.736h1.053M8 15.368A7.368 7.368 0 118 .632a7.368 7.368 0 010 14.736z"
        stroke={color}
      />
    </svg>
  );
}

export function ArrowRight(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox={`0 0 15 15`} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.727 7.5h9.546M7.5 11.875l5-4.375-5-4.375"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowRightShaped(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 18;
  const height = props.height || 18;

  const color = props.color || theme.palette.primary.main;
  return (
    <svg width={width} height={width} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.44993 13.2937C6.27493 13.1062 6.18743 12.8968 6.18743 12.6656C6.18743 12.4343 6.27493 12.2374 6.44993 12.0749L9.52493 8.98118L6.43118 5.86868C6.25618 5.71868 6.17181 5.51868 6.17806 5.26868C6.18431 5.01868 6.27493 4.81243 6.44993 4.64993C6.61243 4.47493 6.80931 4.39056 7.04056 4.39681C7.27181 4.40306 7.46868 4.48743 7.63118 4.64993L11.3624 8.38118C11.4374 8.45618 11.4999 8.54681 11.5499 8.65306C11.5999 8.75931 11.6249 8.86868 11.6249 8.98118C11.6249 9.10618 11.5999 9.21868 11.5499 9.31868C11.4999 9.41868 11.4374 9.50618 11.3624 9.58118L7.64993 13.2937C7.48743 13.4562 7.28743 13.5343 7.04993 13.5281C6.81243 13.5218 6.61243 13.4437 6.44993 13.2937Z"
        fill={color}
      />
    </svg>
  );
}

export function CloseIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 1l4 4m4 4L5 5m0 0l4-4M5 5L1 9" stroke={color} strokeWidth={1.2} strokeLinecap="round" />
    </svg>
  );
}

export function EuroIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg
      data-testid="euro-coin"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0a11 11 0 100 22 11 11 0 000-22zm0 20a9 9 0 110-17.999A9 9 0 0111 20zm.59-13.33a3.34 3.34 0 012.62 1.38 1 1 0 001.659-.105 1 1 0 00-.079-1.115 5.32 5.32 0 00-4.2-2.16A5.57 5.57 0 006.46 8.5H5a1 1 0 000 2h1v1H5a1 1 0 000 2h1.46a5.57 5.57 0 005.13 3.83 5.32 5.32 0 004.2-2.16A1 1 0 1014.21 14a3.34 3.34 0 01-2.62 1.38 3.42 3.42 0 01-2.92-1.88H11a1 1 0 000-2H8.05A4.233 4.233 0 018 11c.007-.168.023-.335.05-.5H11a1 1 0 000-2H8.67a3.42 3.42 0 012.92-1.83z"
        fill={color}
      />
    </svg>
  );
}

export function ArrowNext(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.667 18.667L11 10 1.667 1.333"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ShoppingBagIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.417 8.25a.458.458 0 00.458-.458v-.917a.458.458 0 10-.917 0v.917a.458.458 0 00.459.458zm-1.834 0a.458.458 0 00.459-.458v-.917a.458.458 0 10-.917 0v.917a.458.458 0 00.458.458zm4.125-5.5h-.632l-.793-1.581a.458.458 0 10-.816.412l.582 1.169H3.951l.582-1.169a.458.458 0 00-.816-.412L2.924 2.75h-.632a1.375 1.375 0 00-.422 2.677l.34 3.419a1.375 1.375 0 001.374 1.237h3.84A1.375 1.375 0 008.8 8.846l.34-3.42a1.375 1.375 0 00-.432-2.676zm-.83 6.004a.458.458 0 01-.458.413H3.58a.458.458 0 01-.459-.413L2.796 5.5h5.408L7.88 8.754zm.83-4.17H2.292a.458.458 0 010-.917h6.416a.458.458 0 010 .916z"
        fill={color}
      />
    </svg>
  );
}

export function ThinArrowRight(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13 5L9 1m4 4L9 9m4-4H.5" stroke={color} strokeWidth={1.3} />
    </svg>
  );
}

export function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.666 10.836L9.502 8.689a5.25 5.25 0 10-.811.81l2.147 2.147a.583.583 0 00.828 0 .583.583 0 000-.81zM5.418 9.5a4.083 4.083 0 110-8.167 4.083 4.083 0 010 8.167z"
        fill={color}
      />
    </svg>
  );
}

export function ReadIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.702.945a5.93 5.93 0 00-4.203.853A5.93 5.93 0 002.292.879c-.333.002-.666.03-.994.087a.458.458 0 00-.38.459v5.5a.458.458 0 00.535.458 4.996 4.996 0 013.782.876l.055.032h.05a.417.417 0 00.321 0h.05l.055-.032a4.996 4.996 0 013.782-.926.458.458 0 00.536-.459v-5.5a.459.459 0 00-.38-.43zm-4.66 6.09a5.899 5.899 0 00-2.75-.678h-.46V1.774c.154-.009.307-.009.46 0a4.978 4.978 0 012.75.825v4.437zm4.124-.66h-.458c-.958 0-1.902.233-2.75.68V2.598a4.978 4.978 0 012.75-.825c.153-.009.306-.009.458 0v4.602zm.536 1.903A5.93 5.93 0 005.5 9.13a5.93 5.93 0 00-4.202-.853.458.458 0 00-.38.527.458.458 0 00.535.362 4.996 4.996 0 013.782.875.458.458 0 00.531 0 4.996 4.996 0 013.782-.875.458.458 0 00.536-.362.46.46 0 00-.38-.527z"
        fill={color}
      />
    </svg>
  );
}

export function DeleteBinIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.63 1.813a.25.25 0 00-.238.17l-.25.753h4.38l-.25-.753a.25.25 0 00-.238-.17H6.63zm5.473.923l-.409-1.227a1.75 1.75 0 00-1.66-1.196H6.63a1.75 1.75 0 00-1.66 1.196L4.56 2.736H1.063a.75.75 0 000 1.5h.913l.575 8.615a3.75 3.75 0 003.741 3.5h4.08a3.75 3.75 0 003.741-3.5l.574-8.615h.914a.75.75 0 000-1.5h-3.498zm1.081 1.5H3.48l.567 8.515a2.25 2.25 0 002.245 2.1h4.08a2.25 2.25 0 002.244-2.1l.568-8.515zm-6.468 1.73a.75.75 0 01.75.75v5.654a.75.75 0 01-1.5 0V6.716a.75.75 0 01.75-.75zm3.981.75a.75.75 0 00-1.5 0v5.654a.75.75 0 001.5 0V6.716z"
        fill={color}
      />
    </svg>
  );
}

export function MinusIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.379 9H5.404m3.653 7.466c-4.109 0-7.44-3.342-7.44-7.466 0-4.124 3.331-7.467 7.44-7.467 4.11 0 7.44 3.343 7.44 7.467s-3.33 7.466-7.44 7.466z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function PlusIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.03 12.333V9m0-3.333V9m0 0h3.321M9.03 9H5.708m3.322 7.466c-4.11 0-7.44-3.342-7.44-7.466 0-4.124 3.33-7.467 7.44-7.467 4.109 0 7.44 3.343 7.44 7.467s-3.331 7.466-7.44 7.466z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function AlertIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  let { width, height, color, ...others } = props;
  width = width || 24;
  height = height || 24;

  color = color || theme.palette.text.primary;

  return (
    <svg {...others} width={width} height={height} viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.00078 2.89999C6.00078 2.62385 5.77692 2.39999 5.50078 2.39999C5.22464 2.39999 5.00078 2.62385 5.00078 2.89999H6.00078ZM5.00078 5.29999C5.00078 5.57613 5.22464 5.79999 5.50078 5.79999C5.77692 5.79999 6.00078 5.57613 6.00078 5.29999H5.00078ZM6.00078 6.79999C6.00078 6.52385 5.77692 6.29999 5.50078 6.29999C5.22464 6.29999 5.00078 6.52385 5.00078 6.79999H6.00078ZM5.00078 6.80599C5.00078 7.08213 5.22464 7.30599 5.50078 7.30599C5.77692 7.30599 6.00078 7.08213 6.00078 6.80599H5.00078ZM5.00078 2.89999V5.29999H6.00078V2.89999H5.00078ZM5.00078 6.79999V6.80599H6.00078V6.79999H5.00078ZM5.50078 8.69999C3.45733 8.69999 1.80078 7.04344 1.80078 4.99999H0.800781C0.800781 7.59573 2.90504 9.69999 5.50078 9.69999V8.69999ZM9.20078 4.99999C9.20078 7.04344 7.54423 8.69999 5.50078 8.69999V9.69999C8.09652 9.69999 10.2008 7.59573 10.2008 4.99999H9.20078ZM5.50078 1.29999C7.54423 1.29999 9.20078 2.95653 9.20078 4.99999H10.2008C10.2008 2.40425 8.09652 0.299988 5.50078 0.299988V1.29999ZM5.50078 0.299988C2.90504 0.299988 0.800781 2.40425 0.800781 4.99999H1.80078C1.80078 2.95653 3.45733 1.29999 5.50078 1.29999V0.299988Z"
        fill={color}
      />
    </svg>
  );
}

export function DocumentLoadIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.802 9h-3.75a.75.75 0 000 1.5h3.75a.75.75 0 100-1.5zm.75 6h-6a.75.75 0 01-.75-.75V3.75a.75.75 0 01.75-.75h3.75v2.25a2.25 2.25 0 002.25 2.25h2.25v.75a.75.75 0 001.5 0v-1.5a.643.643 0 00-.053-.247v-.068a.8.8 0 00-.142-.21l-4.5-4.5a.75.75 0 00-.217-.143h-.06a.66.66 0 00-.24-.082h-4.5a2.25 2.25 0 00-2.25 2.25v10.5a2.25 2.25 0 002.25 2.25h6a.75.75 0 100-1.5h-.038zm-.75-10.942L11.737 6h-1.185a.75.75 0 01-.75-.75V4.058zm4.178 11.16a.809.809 0 00-.382-.202.75.75 0 10.382.201zM9.802 12h-3.75a.75.75 0 100 1.5h3.75a.75.75 0 100-1.5zm3.645-2.25a2.25 2.25 0 00-1.95 1.125.753.753 0 001.305.75.75.75 0 11.645 1.125.75.75 0 000 1.5 2.25 2.25 0 100-4.5zM6.052 7.5h.75a.75.75 0 100-1.5h-.75a.75.75 0 000 1.5z"
        fill={color}
      />
    </svg>
  );
}

export function DocumentSentIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.625 15h-4.5a.75.75 0 01-.75-.75V3.75a.75.75 0 01.75-.75h3.75v2.25a2.25 2.25 0 002.25 2.25h2.25v3.75a.75.75 0 101.5 0v-4.5-.045a.982.982 0 00-.045-.202v-.068a.804.804 0 00-.143-.21l-4.5-4.5a.802.802 0 00-.21-.143.218.218 0 00-.075 0A.825.825 0 008.67 1.5H4.125a2.25 2.25 0 00-2.25 2.25v10.5a2.25 2.25 0 002.25 2.25h4.5a.75.75 0 100-1.5zm.75-10.942L11.318 6h-1.193a.75.75 0 01-.75-.75V4.058zM5.625 10.5h4.5a.75.75 0 100-1.5h-4.5a.75.75 0 000 1.5zm3 1.5h-3a.75.75 0 100 1.5h3a.75.75 0 100-1.5zm-3-4.5h.75a.75.75 0 000-1.5h-.75a.75.75 0 000 1.5zm10.283 4.717a.75.75 0 00-1.066 0l-2.467 2.476-.967-.976a.752.752 0 10-1.066 1.066l1.5 1.5a.75.75 0 001.066 0l3-3a.75.75 0 000-1.066z"
        fill={color}
      />
    </svg>
  );
}

export function DocumentToSignIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.533 12.533l-1.816-1.816a.75.75 0 00-1.065 0l-2.684 2.685a.75.75 0 00-.218.533v1.815a.75.75 0 00.75.75h1.815a.748.748 0 00.533-.218l2.684-2.684a.75.75 0 000-1.066zM12 15h-.75v-.75l1.935-1.935.75.75L12 15zm-4.5 0h-3a.75.75 0 01-.75-.75V3.75A.75.75 0 014.5 3h3.75v2.25A2.25 2.25 0 0010.5 7.5h2.25v.75a.75.75 0 101.5 0v-1.5-.045a.982.982 0 00-.045-.202v-.068a.804.804 0 00-.143-.21l-4.5-4.5a.802.802 0 00-.21-.143.24.24 0 00-.067 0l-.24-.082H4.5a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 16.5h3a.75.75 0 100-1.5zM9.75 4.058L11.693 6H10.5a.75.75 0 01-.75-.75V4.058zM6 10.5h4.5a.75.75 0 100-1.5H6a.75.75 0 000 1.5zm0-3h.75a.75.75 0 000-1.5H6a.75.75 0 000 1.5zM7.5 12H6a.75.75 0 100 1.5h1.5a.75.75 0 100-1.5z"
        fill={color}
      />
    </svg>
  );
}

export function CafMessageIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.857 14.794l.283-.855-.393-.13-.354.214.464.77zm1.929-1.93l-.758-.485-.232.363.136.407.854-.285zm.964 2.886l-.282.855a.9.9 0 001.136-1.14l-.854.285zm-3.357-1.727c-.84.506-2.235.827-3.393.827v1.8c1.39 0 3.13-.367 4.322-1.085l-.93-1.542zM9 14.85A5.85 5.85 0 013.15 9h-1.8A7.65 7.65 0 009 16.65v-1.8zM3.15 9A5.85 5.85 0 019 3.15v-1.8A7.65 7.65 0 001.35 9h1.8zM9 3.15A5.85 5.85 0 0114.85 9h1.8A7.65 7.65 0 009 1.35v1.8zM14.85 9c0 1.238-.277 2.527-.822 3.38l1.516.969c.795-1.244 1.106-2.912 1.106-4.349h-1.8zm-2.275 6.649l2.893.956.564-1.71-2.892-.956-.565 1.71zm4.029-.184l-.965-2.886-1.707.57.964 2.886 1.708-.57z"
        fill={color}
      />
    </svg>
  );
}

export function DropDownIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5 7.5l5 5 5-5" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function SearchCircledIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.167 9.2l1.633 1.6m-3.267-.933a2.333 2.333 0 110-4.667 2.333 2.333 0 010 4.667zM8 14.533A6.533 6.533 0 118 1.467a6.533 6.533 0 010 13.066z"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function VerifiedCircledIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg
      data-testid="verified-circled"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.733 8l2.8 2.333 3.734-4.666M8 14.533A6.533 6.533 0 118 1.467a6.533 6.533 0 010 13.066z"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function DeniedCircledIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg
      data-testid="denied-circled"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.333 10.041L8 8M5.958 5.958L8 8m0 0l2.333-2.042M8 8L5.958 10.04M8 14.534A6.533 6.533 0 118 1.467a6.533 6.533 0 010 13.066z"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function DownloadCircledIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg
      data-testid="download-circled"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.958 8.292L8 10.333m0 0l2.042-2.041M8 10.333V5.667m0 8.866A6.533 6.533 0 118 1.467a6.533 6.533 0 010 13.066z"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function InfoUploadIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.357 10.8a.5.5 0 101 0h-1zm.5-3.267h.5v-.5h-.5v.5zm-.5-2.333a.5.5 0 001 0h-1zm1-.01a.5.5 0 00-1 0h1zM6.486 7.034a.5.5 0 000 1v-1zm0 3.267a.5.5 0 000 1v-1zm2.742 1a.5.5 0 100-1v1zm-.871-.5V7.533h-1V10.8h1zm0-5.6v-.01h-1v.01h1zM6.486 8.033h1.371v-1H6.486v1zm0 3.267h2.742v-1H6.486v1zm1.371-9.333c3.249 0 5.9 2.691 5.9 6.033h1c0-3.875-3.08-7.033-6.9-7.033v1zM1.957 8c0-3.342 2.651-6.033 5.9-6.033v-1C4.037.967.957 4.125.957 8h1zm5.9 6.034c-3.249 0-5.9-2.692-5.9-6.034h-1c0 3.875 3.08 7.034 6.9 7.034v-1zm0 1c3.82 0 6.9-3.16 6.9-7.034h-1c0 3.342-2.651 6.034-5.9 6.034v1z"
        fill={color}
      />
    </svg>
  );
}

export function ImagePickerIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17 0H3a3 3 0 00-3 3v14a3 3 0 003 3h14c.165-.002.328-.019.49-.05l.3-.07H17.91l.37-.14.13-.07c.1-.06.21-.11.31-.18a3.78 3.78 0 00.38-.32l.07-.09c.098-.1.188-.206.27-.32l.09-.13c.07-.111.13-.228.18-.35.027-.048.05-.098.07-.15.05-.12.08-.25.12-.38v-.15c.057-.195.09-.397.1-.6V3a3 3 0 00-3-3zM3 18a1 1 0 01-1-1v-4.31l3.29-3.3a1 1 0 011.42 0l8.6 8.61H3zm15-1a1 1 0 01-.07.36c-.023.049-.05.096-.08.14a.948.948 0 01-.09.12l-5.35-5.35.88-.88a1.002 1.002 0 011.42 0l3.29 3.3V17zm0-5.14L16.12 10a3.08 3.08 0 00-4.24 0l-.88.88L8.12 8a3.08 3.08 0 00-4.24 0L2 9.86V3a1 1 0 011-1h14a1 1 0 011 1v8.86zM11.5 4a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
        fill={color}
      />
    </svg>
  );
}

export function UploadIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.532 5.783L8.25 4.058v7.192a.75.75 0 101.5 0V4.058l1.717 1.725a.75.75 0 001.066 0 .75.75 0 000-1.065l-3-3a.75.75 0 00-.248-.158.75.75 0 00-.57 0 .75.75 0 00-.248.158l-3 3a.753.753 0 101.066 1.065zM15.75 10.5a.75.75 0 00-.75.75v3a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75v-3a.75.75 0 00-1.5 0v3a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25v-3a.75.75 0 00-.75-.75z"
        fill={color}
      />
    </svg>
  );
}

export function PencilCircledIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 26;
  const height = props.height || 26;

  const color = props.color || theme.palette.text.secondary;
  return (
    <svg
      data-testid="pencil-circled"
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.1998 14.6L7.4927 13.8929L7.1998 14.1858V14.6H8.1998ZM14.5998 8.20005L15.3069 7.49294C15.1194 7.3054 14.865 7.20005 14.5998 7.20005C14.3346 7.20005 14.0802 7.3054 13.8927 7.49294L14.5998 8.20005ZM17.7998 11.4L18.5069 12.1072C18.8974 11.7166 18.8974 11.0835 18.5069 10.6929L17.7998 11.4ZM11.3998 17.8V18.8H11.814L12.1069 18.5072L11.3998 17.8ZM8.1998 17.8H7.1998C7.1998 18.3523 7.64752 18.8 8.1998 18.8V17.8ZM12.9998 23.2C7.3665 23.2 2.7998 18.6334 2.7998 13H0.799805C0.799805 19.7379 6.26193 25.2 12.9998 25.2V23.2ZM23.1998 13C23.1998 18.6334 18.6331 23.2 12.9998 23.2V25.2C19.7377 25.2 25.1998 19.7379 25.1998 13H23.1998ZM12.9998 2.80005C18.6331 2.80005 23.1998 7.36674 23.1998 13H25.1998C25.1998 6.26217 19.7377 0.800049 12.9998 0.800049V2.80005ZM12.9998 0.800049C6.26193 0.800049 0.799805 6.26217 0.799805 13H2.7998C2.7998 7.36674 7.3665 2.80005 12.9998 2.80005V0.800049ZM8.90691 15.3072L15.3069 8.90715L13.8927 7.49294L7.4927 13.8929L8.90691 15.3072ZM13.8927 8.90715L17.0927 12.1072L18.5069 10.6929L15.3069 7.49294L13.8927 8.90715ZM17.0927 10.6929L10.6927 17.0929L12.1069 18.5072L18.5069 12.1072L17.0927 10.6929ZM11.3998 16.8H8.1998V18.8H11.3998V16.8ZM9.1998 17.8V14.6H7.1998V17.8H9.1998Z"
        fill={color}
      />
    </svg>
  );
}

export function PencilCircledBackWhiteIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 26;
  const height = props.height || 26;

  const color = props.color || theme.palette.primary.main;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="22" height="22" rx="11" fill="white" />
      <path
        d="M7.59982 13.4667L7.06949 12.9363L6.84982 13.156V13.4667H7.59982ZM13.4665 7.59999L13.9968 7.06966C13.8562 6.92901 13.6654 6.84999 13.4665 6.84999C13.2676 6.84999 13.0768 6.92901 12.9362 7.06966L13.4665 7.59999ZM16.3998 10.5333L16.9301 11.0637C17.223 10.7708 17.223 10.2959 16.9301 10.003L16.3998 10.5333ZM10.5332 16.4V17.15H10.8438L11.0635 16.9303L10.5332 16.4ZM7.59982 16.4H6.84982C6.84982 16.8142 7.18561 17.15 7.59982 17.15V16.4ZM11.9998 21.5167C6.74391 21.5167 2.48315 17.2559 2.48315 12H0.983154C0.983154 18.0843 5.91548 23.0167 11.9998 23.0167V21.5167ZM21.5165 12C21.5165 17.2559 17.2557 21.5167 11.9998 21.5167V23.0167C18.0842 23.0167 23.0165 18.0843 23.0165 12H21.5165ZM11.9998 2.48332C17.2557 2.48332 21.5165 6.74408 21.5165 12H23.0165C23.0165 5.91565 18.0842 0.983322 11.9998 0.983322V2.48332ZM11.9998 0.983322C5.91548 0.983322 0.983154 5.91565 0.983154 12H2.48315C2.48315 6.74408 6.74391 2.48332 11.9998 2.48332V0.983322ZM8.13015 13.997L13.9968 8.13032L12.9362 7.06966L7.06949 12.9363L8.13015 13.997ZM12.9362 8.13032L15.8695 11.0637L16.9301 10.003L13.9968 7.06966L12.9362 8.13032ZM15.8695 10.003L10.0028 15.8697L11.0635 16.9303L16.9301 11.0637L15.8695 10.003ZM10.5332 15.65H7.59982V17.15H10.5332V15.65ZM8.34982 16.4V13.4667H6.84982V16.4H8.34982Z"
        fill={color}
      />
    </svg>
  );
}

export function PersonCircledIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.6 21.8V21a4.8 4.8 0 014.8-4.8h3.2a4.8 4.8 0 014.8 4.8v.8M13 6.6a3.2 3.2 0 100 6.4 3.2 3.2 0 000-6.4zm0 17.6C6.814 24.2 1.8 19.186 1.8 13 1.8 6.814 6.814 1.8 13 1.8c6.185 0 11.2 5.014 11.2 11.2 0 6.186-5.015 11.2-11.2 11.2z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function PeopleIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.01 16.05h1.72a1 1 0 001-1v-.632a2.72 2.72 0 00-2.72-2.72m-3.807-6.937a3.262 3.262 0 01-3.264 3.262 3.262 3.262 0 110-6.523 3.262 3.262 0 013.264 3.261zm-1.088 5.374H4.764c-1.803 0-3.264 1.93-3.264 3.732v1.173a1 1 0 001 1h8.879a1 1 0 001-1v-1.173c0-1.802-1.462-3.732-3.264-3.732zm4.351-.612a2.176 2.176 0 110-4.351 2.176 2.176 0 010 4.35z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function PlusCircledIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.412 13.75V10m0-3.75V10m0 0h3.75m-3.75 0h-3.75m3.75 8.4a8.4 8.4 0 110-16.8 8.4 8.4 0 010 16.8z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function QuestionnaireIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.94 12H6.94C6.62174 12 6.31651 12.1264 6.09147 12.3515C5.86643 12.5765 5.74 12.8817 5.74 13.2C5.74 13.5183 5.86643 13.8235 6.09147 14.0485C6.31651 14.2736 6.62174 14.4 6.94 14.4H12.94C13.2583 14.4 13.5635 14.2736 13.7885 14.0485C14.0136 13.8235 14.14 13.5183 14.14 13.2C14.14 12.8817 14.0136 12.5765 13.7885 12.3515C13.5635 12.1264 13.2583 12 12.94 12ZM14.14 21.6H4.54C4.22174 21.6 3.91651 21.4736 3.69147 21.2485C3.46643 21.0235 3.34 20.7182 3.34 20.4V3.6C3.34 3.28174 3.46643 2.97651 3.69147 2.75147C3.91651 2.52643 4.22174 2.4 4.54 2.4H10.54V6C10.54 6.95477 10.9193 7.87045 11.5944 8.54558C12.2695 9.22071 13.1852 9.59999 14.14 9.59999H17.74V10.8C17.74 11.1183 17.8664 11.4235 18.0915 11.6485C18.3165 11.8736 18.6217 12 18.94 12C19.2582 12 19.5635 11.8736 19.7885 11.6485C20.0136 11.4235 20.14 11.1183 20.14 10.8V8.39999C20.1452 8.37628 20.1452 8.35171 20.14 8.32799C20.1298 8.21614 20.1014 8.1067 20.056 8.00399V7.89599C19.9983 7.77261 19.9213 7.65919 19.828 7.56L12.628 0.36C12.5262 0.264318 12.4084 0.187158 12.28 0.132C12.28 0.132 12.22 0.132 12.184 0.132C12.0657 0.0635731 11.9353 0.0187446 11.8 0H4.6C3.64522 0 2.72955 0.379284 2.05441 1.05441C1.37928 1.72955 1 2.64522 1 3.6V20.4C1 21.3548 1.37928 22.2704 2.05441 22.9456C2.72955 23.6207 3.64522 24 4.6 24H14.2C14.5183 24 14.8235 23.8736 15.0485 23.6485C15.2736 23.4235 15.4 23.1182 15.4 22.8C15.4 22.4817 15.2736 22.1765 15.0485 21.9515C14.8235 21.7264 14.5183 21.6 14.2 21.6H14.14ZM12.94 4.092L16.036 7.2H14.14C13.8217 7.2 13.5165 7.07357 13.2915 6.84852C13.0664 6.62348 12.94 6.31826 12.94 6V4.092ZM19.624 21.948C19.567 21.8964 19.5069 21.8483 19.444 21.804C19.3121 21.7183 19.1657 21.6573 19.012 21.624C18.8192 21.5854 18.6199 21.5947 18.4316 21.6512C18.2432 21.7077 18.0717 21.8096 17.932 21.948C17.8195 22.0595 17.7302 22.1923 17.6693 22.3385C17.6084 22.4847 17.577 22.6416 17.577 22.8C17.577 22.9584 17.6084 23.1152 17.6693 23.2615C17.7302 23.4077 17.8195 23.5404 17.932 23.652C18.1555 23.8737 18.4572 23.9987 18.772 24C18.9695 24.001 19.1643 23.9532 19.3389 23.8608C19.5136 23.7685 19.6627 23.6345 19.7731 23.4706C19.8835 23.3068 19.9518 23.1182 19.9718 22.9217C19.9919 22.7252 19.9631 22.5267 19.888 22.344C19.8228 22.1981 19.7335 22.0643 19.624 21.948ZM12.94 16.8H6.94C6.62174 16.8 6.31651 16.9264 6.09147 17.1515C5.86643 17.3765 5.74 17.6817 5.74 18C5.74 18.3182 5.86643 18.6235 6.09147 18.8485C6.31651 19.0736 6.62174 19.2 6.94 19.2H12.94C13.2583 19.2 13.5635 19.0736 13.7885 18.8485C14.0136 18.6235 14.14 18.3182 14.14 18C14.14 17.6817 14.0136 17.3765 13.7885 17.1515C13.5635 16.9264 13.2583 16.8 12.94 16.8ZM18.772 13.2C18.1397 13.1996 17.5184 13.3657 16.9707 13.6817C16.423 13.9977 15.9682 14.4524 15.652 15C15.5732 15.1371 15.5222 15.2884 15.5019 15.4452C15.4815 15.602 15.4923 15.7613 15.5335 15.9139C15.5747 16.0666 15.6456 16.2096 15.7421 16.3349C15.8387 16.4602 15.9589 16.5652 16.096 16.644C16.2331 16.7228 16.3844 16.7738 16.5412 16.7941C16.698 16.8145 16.8573 16.8037 17.0099 16.7625C17.1626 16.7212 17.3056 16.6504 17.4309 16.5538C17.5562 16.4573 17.6612 16.3371 17.74 16.2C17.8455 16.0173 17.9972 15.8657 18.18 15.7603C18.3628 15.655 18.5701 15.5997 18.781 15.6C18.992 15.6003 19.1991 15.6563 19.3816 15.7621C19.564 15.868 19.7153 16.0201 19.8202 16.2031C19.9252 16.3862 19.98 16.5936 19.9792 16.8045C19.9784 17.0155 19.922 17.2225 19.8157 17.4047C19.7094 17.5869 19.557 17.7379 19.3737 17.8424C19.1905 17.9469 18.9829 18.0013 18.772 18C18.4537 18 18.1485 18.1264 17.9235 18.3515C17.6984 18.5765 17.572 18.8817 17.572 19.2C17.572 19.5182 17.6984 19.8235 17.9235 20.0485C18.1485 20.2736 18.4537 20.4 18.772 20.4C19.7268 20.4 20.6424 20.0207 21.3176 19.3456C21.9927 18.6704 22.372 17.7548 22.372 16.8C22.372 15.8452 21.9927 14.9295 21.3176 14.2544C20.6424 13.5793 19.7268 13.2 18.772 13.2ZM6.94 9.59999H8.14C8.45825 9.59999 8.76348 9.47357 8.98852 9.24852C9.21357 9.02348 9.33999 8.71825 9.33999 8.39999C9.33999 8.08174 9.21357 7.77651 8.98852 7.55147C8.76348 7.32642 8.45825 7.2 8.14 7.2H6.94C6.62174 7.2 6.31651 7.32642 6.09147 7.55147C5.86643 7.77651 5.74 8.08174 5.74 8.39999C5.74 8.71825 5.86643 9.02348 6.09147 9.24852C6.31651 9.47357 6.62174 9.59999 6.94 9.59999Z"
        fill={color}
      />
    </svg>
  );
}

export function SignProfileIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.3969 24H14.4401C14.1161 24 13.8053 23.8736 13.5762 23.6485C13.347 23.4235 13.2183 23.1182 13.2183 22.8V19.896C13.2174 19.7381 13.2482 19.5815 13.309 19.4353C13.3698 19.2891 13.4594 19.1561 13.5726 19.044L17.3969 24ZM17.3969 24C17.5577 24.0009 17.7171 23.9706 17.866 23.9109C18.0149 23.8512 18.1503 23.7632 18.2644 23.652L17.3969 24ZM19.6114 14.819L19.6117 14.8193L22.5685 17.7233L22.6386 17.652L22.5688 17.7236C22.6739 17.826 22.7572 17.9476 22.814 18.0815C22.8708 18.2155 22.9 18.359 22.9 18.504C22.9 18.6489 22.8708 18.7925 22.814 18.9264C22.7572 19.0603 22.6739 19.182 22.5688 19.2843L22.5685 19.2846L18.1947 23.5803C18.1946 23.5804 18.1945 23.5805 18.1944 23.5806C18.0897 23.6825 17.9655 23.7633 17.8288 23.8181C17.692 23.873 17.5454 23.9008 17.3975 23.9H17.3969H14.4401C14.142 23.9 13.8565 23.7837 13.6462 23.5772C13.436 23.3707 13.3183 23.0911 13.3183 22.8L13.3183 19.896L13.3183 19.8954C13.3174 19.7509 13.3456 19.6076 13.4013 19.4737C13.457 19.3399 13.539 19.218 13.6428 19.1152C13.6429 19.1152 13.6429 19.1151 13.643 19.115L18.0168 14.8193L18.0171 14.819C18.1213 14.7159 18.2454 14.6339 18.3822 14.5779C18.5191 14.5219 18.6659 14.493 18.8143 14.493C18.9626 14.493 19.1094 14.5219 19.2463 14.5779C19.3831 14.6339 19.5072 14.7159 19.6114 14.819ZM16.8838 21.7H16.9247L16.9538 21.6713L20.1062 18.5753L20.1788 18.504L20.1062 18.4326L18.8843 17.2326L18.8143 17.1638L18.7442 17.2326L15.5919 20.3286L15.5619 20.358V20.4V21.6V21.7H15.6619H16.8838ZM10.8746 2.4V2.3H10.7746H4.66549C4.31549 2.3 3.97948 2.43653 3.73145 2.68012C3.48337 2.92378 3.34366 3.25463 3.34366 3.6V20.4C3.34366 20.7454 3.48337 21.0762 3.73145 21.3199C3.97948 21.5634 4.31549 21.7 4.66549 21.7H9.5528C9.8509 21.7 10.1364 21.8163 10.3467 22.0228C10.5569 22.2292 10.6746 22.5088 10.6746 22.8C10.6746 23.0911 10.5569 23.3707 10.3467 23.5772C10.1364 23.7837 9.8509 23.9 9.5528 23.9H4.66549C3.71928 23.9 2.81219 23.5308 2.14367 22.8742C1.4752 22.2177 1.1 21.3277 1.1 20.4V3.6C1.1 2.67233 1.4752 1.78228 2.14367 1.12576C2.81219 0.469179 3.71928 0.1 4.66549 0.1H12.0533L12.4288 0.226746L12.4512 0.234306L12.4746 0.231041C12.4973 0.227875 12.5202 0.22734 12.543 0.229437C12.6532 0.281763 12.7547 0.350217 12.8439 0.432432L20.1727 7.63028C20.2547 7.71617 20.3232 7.81352 20.3759 7.91907V8.00399V8.02064L20.3813 8.03639C20.4144 8.13298 20.4372 8.23267 20.4493 8.33384V8.33414V8.33453V8.33493V8.33532V8.33571V8.3361V8.33649V8.33688V8.33727V8.33765V8.33803V8.33841V8.33879V8.33917V8.33955V8.33992V8.34029V8.34067V8.34104V8.3414V8.34177V8.34214V8.3425V8.34286V8.34322V8.34358V8.34394V8.3443V8.34465V8.34501V8.34536V8.34571V8.34606V8.3464V8.34675V8.34709V8.34744V8.34778V8.34812V8.34846V8.34879V8.34913V8.34946V8.34979V8.35013V8.35045V8.35078V8.35111V8.35143V8.35176V8.35208V8.3524V8.35272V8.35304V8.35336V8.35367V8.35398V8.3543V8.35461V8.35492V8.35522V8.35553V8.35584V8.35614V8.35644V8.35674V8.35704V8.35734V8.35764V8.35793V8.35823V8.35852V8.35881V8.3591V8.35939V8.35968V8.35996V8.36025V8.36053V8.36081V8.36109V8.36137V8.36165V8.36193V8.3622V8.36248V8.36275V8.36302V8.36329V8.36356V8.36383V8.36409V8.36436V8.36462V8.36488V8.36514V8.3654V8.36566V8.36592V8.36617V8.36643V8.36668V8.36693V8.36718V8.36743V8.36768V8.36793V8.36817V8.36842V8.36866V8.3689V8.36914V8.36938V8.36962V8.36985V8.37009V8.37032V8.37056V8.37079V8.37102V8.37125V8.37148V8.3717V8.37193V8.37215V8.37238V8.3726V8.37282V8.37304V8.37326V8.37348V8.37369V8.37391V8.37412V8.37433V8.37455V8.37475V8.37496V8.37517V8.37538V8.37558V8.37579V8.37599V8.37619V8.3764V8.3766V8.37679V8.37699V8.37719V8.37738V8.37758V8.37777V8.37796V8.37815V8.37835V8.37853V8.37872V8.37891V8.37909V8.37928V8.37946V8.37964V8.37982V8.38V8.38018V8.38036V8.38054V8.38071V8.38089V8.38106V8.38124V8.38141V8.38158V8.38175V8.38192V8.38208V8.38225V8.38241V8.38258V8.38274V8.3829V8.38307V8.38323V8.38338V8.38354V8.3837V8.38386V8.38401V8.38417V8.38432V8.38447V8.38462V8.38477V8.38492V8.38507V8.38522V8.38536V8.38551V8.38565V8.3858V8.38594V8.38608V8.38622V8.38636V8.3865V8.38664V8.38677V8.38691V8.38704V8.38718V8.38731V8.38744V8.38757V8.3877V8.38783V8.38796V8.38809V8.38822V8.38834V8.38847V8.38859V8.38871V8.38884V8.38896V8.38908V8.3892V8.38932V8.38943V8.38955V8.38967V8.38978V8.3899V8.39001V8.39012V8.39023V8.39034V8.39046V8.39056V8.39067V8.39078V8.39089V8.39099V8.3911V8.3912V8.3913V8.39141V8.39151V8.39161V8.39171V8.39181V8.39191V8.39201V8.3921V8.3922V8.39229V8.39239V8.39248V8.39258V8.39267V8.39276V8.39285V8.39294V8.39303V8.39312V8.39321V8.39329V8.39338V8.39347V8.39355V8.39363V8.39372V8.3938V8.39388V8.39396V8.39404V8.39412V8.3942V8.39428V8.39436V8.39443V8.39451V8.39459V8.39466V8.39474V8.39481V8.39488V8.39495V8.39502V8.39509V8.39517V8.39523V8.3953V8.39537V8.39544V8.3955V8.39557V8.39564V8.3957V8.39577V8.39583V8.39589V8.39595V8.39602V8.39608V8.39614V8.3962V8.39625V8.39631V8.39637V8.39643V8.39648V8.39654V8.3966V8.39665V8.3967V8.39676V8.39681V8.39686V8.39692V8.39697V8.39702V8.39707V8.39712V8.39717V8.39721V8.39726V8.39731V8.39736V8.3974V8.39745V8.39749V8.39754V8.39758V8.39763V8.39767V8.39771V8.39775V8.3978V8.39784V8.39788V8.39792V8.39796V8.39799V8.39803V8.39807V8.39811V8.39815V8.39818V8.39822V8.39825V8.39829V8.39832V8.39836V8.39839V8.39842V8.39846V8.39849V8.39852V8.39855V8.39858V8.39861V8.39864V8.39867V8.3987V8.39873V8.39876V8.39879V8.39881V8.39884V8.39887V8.39889V8.39892V8.39894V8.39897V8.39899V8.39902V8.39904V8.39907V8.39909V8.39911V8.39913V8.39916V8.39918V8.3992V8.39922V8.39924V8.39926V8.39928V8.3993V8.39932V8.39934V8.39935V8.39937V8.39939V8.39941V8.39942V8.39944V8.39946V8.39947V8.39949V8.3995V8.39952V8.39953V8.39955V8.39958V8.3996V8.39963V8.39965V8.39967V8.3997V8.39972V8.39974V8.39976V8.39978V8.39979V8.39981V8.39982V8.39984V8.39986V8.39988V8.39989V8.39991V8.39993V8.39994V8.39996V8.39997V8.39999V10.8C20.4493 11.0911 20.3315 11.3707 20.1213 11.5772C19.9111 11.7837 19.6255 11.9 19.3274 11.9C19.0293 11.9 18.7438 11.7837 18.5335 11.5772C18.3233 11.3707 18.2056 11.0911 18.2056 10.8V9.59999V9.49999H18.1056H14.4401C13.4939 9.49999 12.5868 9.13081 11.9183 8.47423C11.2498 7.81771 10.8746 6.92766 10.8746 5.99999V2.4ZM13.2884 4.02065L13.1183 3.85362V4.092V5.99999C13.1183 6.34536 13.258 6.67621 13.5061 6.91987C13.7541 7.16346 14.0901 7.29999 14.4401 7.29999H16.3828H16.6274L16.4529 7.12865L13.2884 4.02065ZM14.4401 14.3H7.10914C6.81104 14.3 6.5255 14.1837 6.31525 13.9772C6.10506 13.7707 5.98731 13.4911 5.98731 13.2C5.98731 12.9088 6.10506 12.6292 6.31525 12.4228C6.5255 12.2163 6.81104 12.1 7.10914 12.1H14.4401C14.7382 12.1 15.0238 12.2163 15.234 12.4228C15.4442 12.6292 15.5619 12.9088 15.5619 13.2C15.5619 13.4911 15.4442 13.7707 15.234 13.9772C15.0238 14.1837 14.7382 14.3 14.4401 14.3ZM8.33097 9.49999H7.10914C6.81104 9.49999 6.5255 9.38367 6.31525 9.17717C6.10506 8.97074 5.98731 8.69114 5.98731 8.39999C5.98731 8.10884 6.10506 7.82925 6.31525 7.62281C6.5255 7.41632 6.81104 7.29999 7.10914 7.29999H8.33097C8.62907 7.29999 8.91461 7.41632 9.12486 7.62281C9.33505 7.82925 9.4528 8.10884 9.4528 8.39999C9.4528 8.69114 9.33505 8.97074 9.12486 9.17717C8.91461 9.38367 8.62907 9.49999 8.33097 9.49999ZM6.31525 17.2228C6.5255 17.0163 6.81104 16.9 7.10914 16.9H9.5528C9.8509 16.9 10.1364 17.0163 10.3467 17.2228C10.5569 17.4292 10.6746 17.7088 10.6746 18C10.6746 18.2911 10.5569 18.5707 10.3467 18.7772C10.1364 18.9837 9.8509 19.1 9.5528 19.1H7.10914C6.81104 19.1 6.5255 18.9837 6.31525 18.7772C6.10506 18.5707 5.98731 18.2911 5.98731 18C5.98731 17.7088 6.10506 17.4292 6.31525 17.2228Z"
        fill={color}
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function GearIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 24;
  const height = props.height || 24;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#prefix__clip0)" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z" />
        <path d="M14.55 11.25a1.238 1.238 0 00.247 1.365l.045.045a1.5 1.5 0 01-1.06 2.562 1.5 1.5 0 01-1.062-.44l-.045-.044a1.238 1.238 0 00-1.365-.248 1.238 1.238 0 00-.75 1.133v.127a1.5 1.5 0 11-3 0v-.068a1.238 1.238 0 00-.81-1.132 1.238 1.238 0 00-1.365.247l-.045.045a1.5 1.5 0 11-2.123-2.122l.046-.045a1.238 1.238 0 00.247-1.365 1.238 1.238 0 00-1.132-.75H2.25a1.5 1.5 0 110-3h.067a1.237 1.237 0 001.133-.81 1.237 1.237 0 00-.248-1.365l-.044-.045A1.5 1.5 0 115.28 3.217l.045.046a1.237 1.237 0 001.365.247h.06a1.237 1.237 0 00.75-1.132V2.25a1.5 1.5 0 013 0v.067a1.238 1.238 0 00.75 1.133 1.237 1.237 0 001.365-.248l.045-.044a1.5 1.5 0 112.123 2.122l-.045.045a1.237 1.237 0 00-.248 1.365v.06a1.237 1.237 0 001.133.75h.127a1.5 1.5 0 010 3h-.068a1.238 1.238 0 00-1.132.75v0z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ArchiveIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const { width, height, color } = props;
  const desWidth = width || 24;
  const desHeight = height || 24;

  const desColor = color || theme.palette.text.primary;

  return (
    <svg
      width={desWidth}
      height={desHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.786 13.286h6.428M4.286 8.143v11.571c0 .71.575 1.286 1.285 1.286H18.43c.71 0 1.285-.576 1.285-1.286V8.143H4.286zm-.286 0h16a1 1 0 001-1V4a1 1 0 00-1-1H4a1 1 0 00-1 1v3.143a1 1 0 001 1z"
        css={{ transition: "stroke 200ms ease-in-out" }}
        stroke={desColor}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ArchiveFolderIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 38 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.94 4.253a1.78 1.78 0 01-1.78-1.78h20.47a6.23 6.23 0 016.23 6.23v13.34h-1.78V8.703a4.45 4.45 0 00-4.45-4.45H12.94z"
        fill={color}
      />
      <path
        d="M36.08 9.593H18.17a2.7 2.7 0 01-2-.85l-5.57-6a.9.9 0 00-.65-.28H6.03a3.8 3.8 0 00-3.8 3.8v22a4.44 4.44 0 004.44 4.45h24.92a4.45 4.45 0 004.45-4.45l.04-18.67zm-30-8.9H10a2.631 2.631 0 011.95.85l5.58 6a.88.88 0 00.65.29h18.8a.89.89 0 01.89.89v19.57a6.23 6.23 0 01-6.23 6.23H6.72a6.221 6.221 0 01-6.22-6.23v-22a5.58 5.58 0 015.57-5.6h.01z"
        fill={color}
      />
    </svg>
  );
}

export function UploadDocumentIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.533 8.467a.75.75 0 00-.248-.157.75.75 0 00-.57 0 .75.75 0 00-.248.157l-1.5 1.5a.753.753 0 101.066 1.066l.217-.226v1.943a.75.75 0 101.5 0v-1.943l.217.226a.75.75 0 001.23-.245.751.751 0 00-.164-.82l-1.5-1.5zM15 6.705a.982.982 0 00-.045-.202v-.068a.804.804 0 00-.143-.21l-4.5-4.5a.803.803 0 00-.21-.143h-.075a.825.825 0 00-.232-.082H5.25A2.25 2.25 0 003 3.75v10.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0015 14.25v-7.5-.045zm-4.5-2.647L12.443 6H11.25a.75.75 0 01-.75-.75V4.058zm3 10.192a.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75V3.75A.75.75 0 015.25 3H9v2.25a2.25 2.25 0 002.25 2.25h2.25v6.75z"
        fill={color}
      />
    </svg>
  );
}

export function TickIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.125 12.801L3.823 9.5 2.7 10.616l4.426 4.426 9.5-9.5-1.117-1.117-8.383 8.376z" fill={color} />
    </svg>
  );
}

export function QRCodeIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 8h8V0H0v8zm2-6h4v4H2V2zM0 18h8v-8H0v8zm2-6h4v4H2v-4zM10 0v8h8V0h-8zm6 6h-4V2h4v4zM18 16h-2v2h2v-2zM12 10h-2v2h2v-2zM14 12h-2v2h2v-2zM12 14h-2v2h2v-2zM14 16h-2v2h2v-2zM16 14h-2v2h2v-2zM16 10h-2v2h2v-2zM18 12h-2v2h2v-2z"
        fill={color}
      />
    </svg>
  );
}

export function PencilIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;

  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill={color} d="M-1-1h22v22H-1z" />
    </svg>
  );
}

export function CertificateIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#prefix__clip0)" fill={color}>
        <path d="M5.684 17.526a.433.433 0 01-.355-.184L3.723 15.04l-2.762.318a.46.46 0 01-.46-.617L2.833 9.59a.46.46 0 01.576-.221.46.46 0 01.22.58L1.62 14.4l2.274-.262a.461.461 0 01.41.184l1.312 1.883.98-2.182a.46.46 0 01.801.359l-1.302 2.881a.46.46 0 01-.36.258l-.05.005zM12.677 17.526h-.037a.46.46 0 01-.36-.258l-1.265-2.808a.437.437 0 01.796-.359l.948 2.108 1.312-1.882a.46.46 0 01.41-.184l2.302.262-2.049-4.534a.46.46 0 01.801-.36l2.362 5.235a.46.46 0 01-.46.617l-2.763-.318-1.606 2.301a.461.461 0 01-.391.18z" />
        <path d="M7.192 14.63a1.17 1.17 0 01-.373-.06 2.196 2.196 0 01-1.104-1.15 1.34 1.34 0 00-1.294-.921 2.196 2.196 0 01-1.427-.69 2.168 2.168 0 01-.212-1.557 2.44 2.44 0 000-.86 2.408 2.408 0 00-.488-.659 1.708 1.708 0 010-2.84c.2-.19.366-.412.488-.658a2.435 2.435 0 000-.861 1.662 1.662 0 011.635-2.242c.283-.037.558-.126.81-.263a2.38 2.38 0 00.488-.676 2.21 2.21 0 011.1-1.156c.528-.099 1.074.001 1.533.281a1.432 1.432 0 001.666 0 2.168 2.168 0 011.529-.28c.5.233.894.645 1.104 1.155.122.252.287.481.488.676.252.137.527.226.81.263a1.662 1.662 0 011.635 2.242 2.432 2.432 0 000 .86c.122.247.288.47.488.659a1.707 1.707 0 010 2.84c-.2.19-.364.413-.488.658a2.436 2.436 0 000 .861c.126.527.05 1.082-.212 1.556-.373.4-.882.646-1.427.69a1.34 1.34 0 00-1.294.921 1.665 1.665 0 01-2.633.875 1.413 1.413 0 00-1.666 0 3.01 3.01 0 01-1.156.336zm0-13.81a.405.405 0 00-.11 0c-.221.074-.419.419-.612.755a2.14 2.14 0 01-1.874 1.38c-.327.024-.64.145-.898.346-.11.304-.128.634-.05.948a2.96 2.96 0 01-.042 1.225 2.84 2.84 0 01-.667.976c-.263.29-.534.59-.534.833 0 .244.271.543.534.829.285.283.511.621.663.994.095.4.108.815.037 1.22-.078.314-.06.644.05.948.134.189.52.267.898.35.404.055.793.193 1.141.405.306.265.555.59.732.953.194.336.392.686.613.755.324.015.646-.07.92-.244a2.233 2.233 0 012.385 0c.276.17.596.256.92.244.222-.069.42-.419.613-.755.177-.364.426-.688.732-.953.348-.212.737-.35 1.141-.405.378-.083.765-.161.898-.345.11-.306.128-.637.05-.953a3.015 3.015 0 01.038-1.22c.156-.369.384-.702.672-.98.262-.286.534-.585.534-.83 0-.243-.272-.542-.534-.832a2.918 2.918 0 01-.672-.976 3.043 3.043 0 01-.037-1.225c.078-.314.06-.644-.05-.948-.134-.184-.521-.267-.894-.345a2.14 2.14 0 01-1.878-1.381c-.194-.336-.391-.682-.612-.755a1.63 1.63 0 00-.921.244 2.232 2.232 0 01-2.385 0 2.343 2.343 0 00-.796-.226L7.192.82z" />
        <path d="M9.18 11.867a4.565 4.565 0 01-.894-9.045 4.566 4.566 0 11.895 9.046zm0-8.253a3.683 3.683 0 103.683 3.682 3.683 3.683 0 00-3.682-3.678v-.004z" />
        <path d="M8.948 8.793a.46.46 0 01-.308-.13L7.415 7.44a.437.437 0 01.617-.616l.92.92 1.925-1.929a.46.46 0 01.621.622L9.261 8.668a.46.46 0 01-.313.125z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DownloadIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.75 11.026a.74.74 0 00-.53.225.78.78 0 00-.22.544v3.077a.78.78 0 01-.22.544.74.74 0 01-.53.225H3.75a.74.74 0 01-.53-.225.78.78 0 01-.22-.544v-3.077a.78.78 0 00-.22-.544.74.74 0 00-1.06 0 .78.78 0 00-.22.544v3.077c0 .612.237 1.199.659 1.632.422.432.994.675 1.591.675h10.5c.597 0 1.169-.243 1.591-.675.422-.433.659-1.02.659-1.632v-3.077a.78.78 0 00-.22-.544.74.74 0 00-.53-.225zM8.467 12.34c.072.07.156.125.248.162a.69.69 0 00.57 0 .748.748 0 00.248-.162l3-3.077a.783.783 0 000-1.092.744.744 0 00-1.066 0L9.75 9.942V2.563a.78.78 0 00-.22-.544.74.74 0 00-1.06 0 .78.78 0 00-.22.544v7.377l-1.718-1.77A.752.752 0 006 7.947a.737.737 0 00-.532.226.774.774 0 00-.221.546.79.79 0 00.22.546l3 3.077z"
        fill={color}
      />
    </svg>
  );
}

export function EntryIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;

  return (
    <svg width={width} height={height} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.25 17.75c1.275 0 2.25-.975 2.25-2.25v-12c0-1.275-.975-2.25-2.25-2.25H10.5c-.45 0-.75.3-.75.75s.3.75.75.75h3.75c.45 0 .75.3.75.75v12c0 .45-.3.75-.75.75H10.5c-.45 0-.75.3-.75.75s.3.75.75.75h3.75zM11.925 9.2c.075.225.075.45 0 .6 0 .075-.075.15-.15.225l-3 3a.81.81 0 01-.525.225.81.81 0 01-.525-.225c-.3-.3-.3-.75 0-1.05L9.45 10.25h-7.2c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h7.2L7.725 7.025c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0l3 3a.391.391 0 01.075.113c.019.037.037.075.075.112z"
        fill={color}
      />
      <mask id="prefix_entry" maskUnits="userSpaceOnUse" x={1} y={1} width={16} height={17}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.25 17.75c1.275 0 2.25-.975 2.25-2.25v-12c0-1.275-.975-2.25-2.25-2.25H10.5c-.45 0-.75.3-.75.75s.3.75.75.75h3.75c.45 0 .75.3.75.75v12c0 .45-.3.75-.75.75H10.5c-.45 0-.75.3-.75.75s.3.75.75.75h3.75zM11.925 9.2c.075.225.075.45 0 .6 0 .075-.075.15-.15.225l-3 3a.81.81 0 01-.525.225.81.81 0 01-.525-.225c-.3-.3-.3-.75 0-1.05L9.45 10.25h-7.2c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h7.2L7.725 7.025c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0l3 3a.391.391 0 01.075.113c.019.037.037.075.075.112z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#prefix_entry)">
        <path fill={color} d="M0 .5h18v18H0z" />
      </g>
    </svg>
  );
}

export function FlagIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.475 2.225c.225-.225.525-.3.825-.15.3.15.45.375.45.675v9a.68.68 0 01-.225.525c-.15.15-1.125.975-3.525.975-1.175 0-2.158-.382-3.068-.735l-.232-.09a27.466 27.466 0 01-.511-.178c-.711-.252-1.401-.497-2.189-.497-1.2 0-1.95.225-2.25.375V17c0 .45-.3.75-.75.75s-.75-.3-.75-.75V2.75a.68.68 0 01.225-.525C2.625 2.075 3.6 1.25 6 1.25c1.275 0 2.325.375 3.3.825.173.058.342.118.511.178.711.252 1.401.497 2.189.497 1.8 0 2.475-.525 2.475-.525zM12 11.75c1.2 0 1.95-.225 2.25-.375V3.95c-.525.15-1.275.3-2.25.3-1.275 0-2.325-.375-3.3-.825a27.884 27.884 0 01-.511-.178C7.478 2.995 6.788 2.75 6 2.75c-1.2 0-1.95.225-2.25.375v7.425c.525-.15 1.275-.3 2.25-.3 1.275 0 2.325.375 3.3.825.173.058.342.118.511.178.711.252 1.401.497 2.189.497z"
        fill="#000"
      />
      <mask
        id="prefix__a"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={2}
        y={1}
        width={14}
        height={17}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.475 2.225c.225-.225.525-.3.825-.15.3.15.45.375.45.675v9a.68.68 0 01-.225.525c-.15.15-1.125.975-3.525.975-1.175 0-2.158-.382-3.068-.735l-.232-.09a27.466 27.466 0 01-.511-.178c-.711-.252-1.401-.497-2.189-.497-1.2 0-1.95.225-2.25.375V17c0 .45-.3.75-.75.75s-.75-.3-.75-.75V2.75a.68.68 0 01.225-.525C2.625 2.075 3.6 1.25 6 1.25c1.275 0 2.325.375 3.3.825.173.058.342.118.511.178.711.252 1.401.497 2.189.497 1.8 0 2.475-.525 2.475-.525zM12 11.75c1.2 0 1.95-.225 2.25-.375V3.95c-.525.15-1.275.3-2.25.3-1.275 0-2.325-.375-3.3-.825a27.884 27.884 0 01-.511-.178C7.478 2.995 6.788 2.75 6 2.75c-1.2 0-1.95.225-2.25.375v7.425c.525-.15 1.275-.3 2.25-.3 1.275 0 2.325.375 3.3.825.173.058.342.118.511.178.711.252 1.401.497 2.189.497z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#prefix__a)">
        <path fill={color} d="M0 .5h18v18H0z" />
      </g>
    </svg>
  );
}

export function TrendingDownIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 14c0 .075 0 .225-.075.3a.904.904 0 01-.375.375c-.075.075-.225.075-.3.075h-4.5c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h2.7l-5.325-5.325L6.9 11.15c-.3.3-.75.3-1.05 0L.225 5.525c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0l5.1 5.1L9.6 6.35c.3-.3.75-.3 1.05 0l5.85 5.85V9.5c0-.45.3-.75.75-.75s.75.3.75.75V14z"
        fill="#000"
      />
      <mask
        id="prefix__b"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={4}
        width={18}
        height={11}
      >
        <path
          d="M18 14c0 .075 0 .225-.075.3a.904.904 0 01-.375.375c-.075.075-.225.075-.3.075h-4.5c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h2.7l-5.325-5.325L6.9 11.15c-.3.3-.75.3-1.05 0L.225 5.525c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0l5.1 5.1L9.6 6.35c.3-.3.75-.3 1.05 0l5.85 5.85V9.5c0-.45.3-.75.75-.75s.75.3.75.75V14z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#prefix__b)">
        <path fill={color} d="M0 .5h18v18H0z" />
      </g>
    </svg>
  );
}

export function ReadMessageIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 40;
  const height = props.height || 40;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 6.5c0-.3.2-.5.5-.5s.5.2.5.5V10c0 .85-.65 1.5-1.5 1.5H2c-.85 0-1.5-.65-1.5-1.5V3c0-.85.65-1.5 1.5-1.5h5.5c.3 0 .5.2.5.5s-.2.5-.5.5H2c-.3 0-.5.2-.5.5v7c0 .3.2.5.5.5h7c.3 0 .5-.2.5-.5V6.5zM5.85 7.85l5.5-5.5c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0L5.5 6.8 4.35 5.65c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l1.5 1.5c.1.1.2.15.35.15.15 0 .25-.05.35-.15z"
        fill="#000"
      />
      <mask id="prefix_read" maskUnits="userSpaceOnUse" x={0} y={1} width={12} height={11}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5 6.5c0-.3.2-.5.5-.5s.5.2.5.5V10c0 .85-.65 1.5-1.5 1.5H2c-.85 0-1.5-.65-1.5-1.5V3c0-.85.65-1.5 1.5-1.5h5.5c.3 0 .5.2.5.5s-.2.5-.5.5H2c-.3 0-.5.2-.5.5v7c0 .3.2.5.5.5h7c.3 0 .5-.2.5-.5V6.5zM5.85 7.85l5.5-5.5c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0L5.5 6.8 4.35 5.65c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l1.5 1.5c.1.1.2.15.35.15.15 0 .25-.05.35-.15z"
          fill={color}
        />
      </mask>
      <g mask="url(#prefix_read)">
        <path fill={color} d="M0 .5h12v12H0z" />
      </g>
    </svg>
  );
}

export function InProgressIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  let { width, height, color, ...others } = props;
  width = width || 40;
  height = height || 40;

  color = color || theme.palette.text.primary;

  return (
    <svg
      {...others}
      width={width}
      height={height}
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.5 9.2a4.2 4.2 0 01-2.598-7.5M5.5.8a4.2 4.2 0 012.598 7.5M7.9 6.5v2.1H10M1 1.4h2.1v2.1"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function TargetIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();

  const width = props.width || 40;
  const height = props.height || 40;

  return (
    <svg width={width} height={height} viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.57 1.904c3.475 0 6.872 1.03 9.762 2.958a17.552 17.552 0 016.47 7.875 17.528 17.528 0 01-3.808 19.124 17.59 17.59 0 01-19.148 3.804 17.565 17.565 0 01-7.885-6.463A17.533 17.533 0 015.146 7.044a17.582 17.582 0 0112.424-5.14zm0 1.848c-3.11-.003-6.15.916-8.737 2.64a15.705 15.705 0 00-5.794 7.045 15.683 15.683 0 003.4 17.114 15.737 15.737 0 0017.133 3.408 15.717 15.717 0 007.058-5.782 15.687 15.687 0 001.457-14.732 15.689 15.689 0 00-8.502-8.498 15.727 15.727 0 00-6.015-1.195zm0 3.694c2.378 0 4.702.704 6.679 2.023a12.01 12.01 0 014.428 5.389 11.992 11.992 0 01-2.606 13.085 12.027 12.027 0 01-13.101 2.602 12.018 12.018 0 01-5.395-4.422 11.996 11.996 0 011.495-15.16 12.03 12.03 0 018.5-3.517zm0 1.847c-2.012 0-3.978.596-5.651 1.712a10.148 10.148 0 00-1.542 15.631 10.177 10.177 0 0011.086 2.203 10.169 10.169 0 004.565-3.742 10.15 10.15 0 00-1.265-12.828 10.178 10.178 0 00-7.193-2.976zm0 3.694a6.478 6.478 0 015.98 3.992 6.457 6.457 0 01-1.402 7.045 6.476 6.476 0 01-11.05-4.571c0-1.715.681-3.36 1.895-4.572a6.477 6.477 0 014.577-1.894zm0 1.848a4.628 4.628 0 00-4.271 2.85 4.612 4.612 0 001.002 5.033 4.626 4.626 0 007.893-3.265c0-1.225-.487-2.4-1.354-3.266a4.626 4.626 0 00-3.27-1.352z"
        fill={theme.palette.primary.main}
      />
      <path
        d="M32.771 5.64L18.225 20.167a.926.926 0 01-1.309-1.308L31.462 4.332v-3.31A.922.922 0 0132.758.08a.925.925 0 01.543.941v2.771h2.775a.924.924 0 010 1.847H32.77z"
        fill={theme.palette.secondary.main}
      />
    </svg>
  );
}

export function CanAccessIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();

  const width = props.width || 40;
  const height = props.height || 40;
  return (
    <svg width={width} height={height} viewBox="0 0 31 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.601 1.78a4.45 4.45 0 00-4.45 4.45v24.92A4.45 4.45 0 006.6 35.6h17.8a4.45 4.45 0 004.45-4.45V6.23a4.45 4.45 0 00-4.45-4.45H6.6zm0-1.78h17.8a6.231 6.231 0 016.23 6.23v24.92a6.23 6.23 0 01-6.23 6.23H6.6a6.23 6.23 0 01-6.23-6.23V6.23A6.23 6.23 0 016.601 0z"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M11.312 25.18a.891.891 0 011.26 1.26L9.012 30a.91.91 0 01-1.26 0l-1.78-1.78a.91.91 0 010-1.26.89.89 0 011.26 0l1.15 1.15 2.93-2.93zm4.19 1.52h7.09a.89.89 0 01.16 1.76h-7.25a.89.89 0 110-1.78v.02zm-2.93-10.42a.9.9 0 01.1 1.14l-.1.12-3.56 3.56a.88.88 0 01-1.13.1l-.13-.1-1.78-1.78a.91.91 0 010-1.26.9.9 0 011.14-.1l.12.1 1.15 1.15 2.93-2.93a.89.89 0 011.26 0zm2.93 1.52h7.09a.89.89 0 01.684 1.458.881.881 0 01-.524.302h-7.25a.89.89 0 110-1.78v.02zm-2.93-10.42a.9.9 0 01.1 1.14l-.1.12-3.56 3.56a.88.88 0 01-1.13.1l-.13-.1-1.78-1.78a.91.91 0 010-1.26.9.9 0 011.14-.1l.12.1 1.15 1.15 2.93-2.93a.89.89 0 011.26-.04v.04zm2.93 1.52h7.09a.888.888 0 01.683 1.46.9.9 0 01-.523.31h-7.25a.89.89 0 110-1.78v.01z"
        fill={theme.palette.secondary.main}
      />
    </svg>
  );
}

export function CannotAccessIcon(props: React.SVGProps<SVGSVGElement>) {
  const width = props.width || 40;
  const height = props.height || 40;
  return (
    <svg width={width} height={height} viewBox="0 0 31 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.96 1.733a4.333 4.333 0 00-4.332 4.333V30.33a4.333 4.333 0 004.333 4.333h17.331a4.333 4.333 0 004.333-4.333V6.066a4.333 4.333 0 00-4.333-4.333H6.961zM6.96 0h17.332a6.066 6.066 0 016.066 6.066V30.33a6.067 6.067 0 01-6.066 6.066H6.961A6.067 6.067 0 01.895 30.33V6.066A6.066 6.066 0 016.96 0z"
        fill="#FF4A7B"
      />
      <path
        d="M15.628 25.998h6.904a.866.866 0 01.666 1.42.857.857 0 01-.51.293h-7.06a.867.867 0 010-1.733v.02zm0-8.666h6.904a.866.866 0 01.665 1.422.877.877 0 01-.51.301h-7.059a.867.867 0 010-1.733v.01zm0-8.627h6.904a.866.866 0 01.665 1.422.877.877 0 01-.51.301h-7.059a.867.867 0 010-1.733v.01z"
        fill="#FF4A7B"
      />
    </svg>
  );
}

export function AddSignatureIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();

  const width = props.width || 40;
  const height = props.height || 40;
  return (
    <svg width={width} height={height} viewBox="0 0 42 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.97 17.8h14.24a.89.89 0 01.16 1.76H8.97a.89.89 0 01-.16-1.77l.16.01zM19.65 0a2.68 2.68 0 012.67 2.67v7.12a.89.89 0 00.89.89h5.34a2.67 2.67 0 012.67 2.67h-1.78a.89.89 0 00-.89-.89h-5.34a2.67 2.67 0 01-2.67-2.67V2.67a.89.89 0 00-.89-.89V0zm-5.34 8.9a.89.89 0 01.683 1.458.88.88 0 01-.524.302h-5.5a.89.89 0 01-.16-1.77h5.5v.01z"
        fill={theme.palette.primary.main}
      />
      <path
        d="M7.19 1.78a4.45 4.45 0 00-4.45 4.45v24.92a4.45 4.45 0 004.45 4.45h17.8a4.46 4.46 0 004.45-4.45V12.21a.93.93 0 00-.21-.57l-8-9.54a.9.9 0 00-.69-.32H7.19zm0-1.78h13.4a2.64 2.64 0 012.05 1l8 9.54c.4.48.619 1.085.62 1.71v18.94a6.23 6.23 0 01-6.23 6.23H7.23A6.23 6.23 0 011 31.19V6.23A6.23 6.23 0 017.19 0z"
        fill={theme.palette.primary.main}
      />
      <path
        d="M7.844 30.136a.75.75 0 101.312.728l-1.312-.728zM17 29.5l.592-.46-.592.46zm5-1.5l-.639.393L22 28zM9.156 30.864c.132-.237.492-.635 1.069-1.051.56-.404 1.26-.78 2.007-1.008 1.48-.454 3.028-.32 4.176 1.155l1.184-.92c-1.652-2.124-3.938-2.24-5.8-1.67a8.54 8.54 0 00-2.445 1.226c-.658.475-1.218 1.027-1.503 1.54l1.312.728zm7.252-.904c.448.577.902 1.024 1.387 1.204.272.1.577.126.878.017.289-.104.49-.3.628-.488.256-.35.398-.825.494-1.23.101-.426.18-.911.256-1.331.079-.442.153-.815.245-1.093.045-.138.085-.223.113-.268.03-.05.02-.01-.056.027-.244.12-.34-.097-.074.142.239.215.592.656 1.082 1.453l1.278-.786c-.51-.828-.953-1.419-1.357-1.782-.377-.339-.961-.68-1.588-.374-.268.131-.443.343-.558.526-.116.187-.2.396-.265.594-.13.393-.22.864-.297 1.297-.081.455-.15.876-.238 1.248-.093.391-.182.604-.246.69-.023.033-.004-.008.074-.036.09-.032.155-.011.152-.012-.063-.024-.297-.17-.724-.718l-1.184.92zm4.953-1.567c.81 1.317 1.49 2.187 2.077 2.68.293.246.615.444.965.517.385.081.76.002 1.065-.232.275-.21.438-.503.54-.76.104-.266.168-.56.208-.85.08-.578.076-1.232.032-1.806l-1.496.116c.04.509.039 1.047-.021 1.484a2.3 2.3 0 01-.12.507c-.05.126-.081.139-.054.118a.234.234 0 01.137-.046c.012 0 .019.002.018.002-.011-.003-.111-.032-.309-.199-.396-.333-.975-1.034-1.764-2.317l-1.278.786z"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M37.136 13.707a1 1 0 00-1.415 0l-10.15 10.15-.433 3.9a1 1 0 001.104 1.105l3.9-.433 10.15-10.15a1 1 0 000-1.415l-3.156-3.157z"
        fill="#fff"
        stroke={theme.palette.error.main}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DeleteProfileIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();

  const width = props.width || 36;
  const height = props.height || 36;
  return (
    <svg width={width} height={height} viewBox="0 0 33 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M26.04 36.61H6.35A6.36 6.36 0 010 30.26V6.35A6.36 6.36 0 016.35 0h19.69a6.36 6.36 0 016.36 6.35v23.91a6.36 6.36 0 01-6.36 6.35zM6.35 1.9A4.46 4.46 0 001.9 6.35v23.91a4.46 4.46 0 004.45 4.45h19.69a4.46 4.46 0 004.46-4.45V6.35a4.46 4.46 0 00-4.46-4.45H6.35z"
        fill={theme.palette.primary.main}
      />
      <path
        d="M16.2 23.92a1 1 0 01-1-1V8.5a.95.95 0 011.9 0v14.42a1 1 0 01-.9 1zM16.2 30.21a.939.939 0 01-1-1v-1a.95.95 0 011.9 0v1a1 1 0 01-.9 1z"
        fill="#FF1473"
      />
    </svg>
  );
}

export function PaidSuccessIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();

  const width = props.width || 50;
  const height = props.height || 50;
  return (
    <svg width={width} height={height} viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.95 51a1.227 1.227 0 01-1.017-.536l-4.61-6.698-7.923.924a1.324 1.324 0 01-1.137-.536 1.35 1.35 0 01-.184-1.259l6.696-14.99c.148-.295.399-.524.704-.643.305-.119.642-.119.947 0 .294.15.522.407.64.72.117.312.115.657-.006.968L3.289 41.904l6.523-.764c.225-.02.451.02.657.113.206.094.384.24.519.423l3.764 5.479 2.812-6.35a1.35 1.35 0 01.66-1.01 1.304 1.304 0 011.68.322 1.35 1.35 0 01.249 1.184 1.344 1.344 0 01-.29.55l-3.738 8.385a1.31 1.31 0 01-1.03.75L14.95 51zM35.01 51h-.105a1.31 1.31 0 01-.61-.241 1.335 1.335 0 01-.42-.51l-3.632-8.171a1.29 1.29 0 01.006-.945c.12-.303.353-.546.646-.68.294-.135.627-.15.93-.041.305.108.556.33.703.621l2.72 6.136 3.764-5.48c.135-.183.313-.329.519-.422.206-.094.432-.133.656-.113l6.538.763-5.877-13.195a1.356 1.356 0 01.164-.816c.139-.247.351-.443.608-.56a1.303 1.303 0 011.526.331L49.92 42.91a1.358 1.358 0 01-.182 1.259 1.325 1.325 0 01-1.138.536l-7.924-.925-4.61 6.698A1.307 1.307 0 0135.01 51z"
        fill="#fff"
      />
      <path
        d="M19.28 42.574a3.305 3.305 0 01-1.07-.174 6.352 6.352 0 01-3.17-3.349 3.895 3.895 0 00-1.421-1.957 3.806 3.806 0 00-2.29-.722 6.264 6.264 0 01-4.093-2.01 6.39 6.39 0 01-.607-4.528 7.2 7.2 0 000-2.505 7.002 7.002 0 00-1.4-1.915 4.946 4.946 0 01-1.6-1.79 5.027 5.027 0 010-4.686c.38-.72.93-1.336 1.6-1.79a6.799 6.799 0 001.4-1.915 7.188 7.188 0 000-2.505 4.9 4.9 0 01.613-4.542 4.784 4.784 0 011.79-1.512 4.71 4.71 0 012.285-.47 6.601 6.601 0 002.324-.764 6.922 6.922 0 001.4-1.969A6.392 6.392 0 0118.197.11a6.16 6.16 0 014.398.817 4.068 4.068 0 002.39.778c.858 0 1.694-.272 2.39-.778A6.145 6.145 0 0131.76.109a6.377 6.377 0 013.17 3.362 6.924 6.924 0 001.4 1.97c.72.397 1.51.656 2.324.763a4.708 4.708 0 012.283.47 4.784 4.784 0 011.791 1.512c.465.646.765 1.4.872 2.192.107.793.018 1.6-.258 2.35a7.185 7.185 0 000 2.505 6.799 6.799 0 001.4 1.915 4.944 4.944 0 011.599 1.79 5.027 5.027 0 010 4.686c-.38.72-.93 1.336-1.6 1.79a7.002 7.002 0 00-1.4 1.915 7.198 7.198 0 000 2.505 6.39 6.39 0 01-.607 4.528 6.265 6.265 0 01-4.094 2.01 3.806 3.806 0 00-2.289.722 3.895 3.895 0 00-1.422 1.957 4.866 4.866 0 01-1.14 2.057 4.773 4.773 0 01-1.965 1.268 4.714 4.714 0 01-2.32.176 4.746 4.746 0 01-2.128-.956 4.016 4.016 0 00-2.39-.79c-.86 0-1.697.276-2.391.79a8.546 8.546 0 01-3.315.978zm0-40.188a1.144 1.144 0 00-.317 0c-.634.214-1.202 1.219-1.756 2.197a6.22 6.22 0 01-2.102 2.815 6.086 6.086 0 01-3.273 1.204 4.703 4.703 0 00-2.575 1.004 4.794 4.794 0 00-.145 2.76 8.736 8.736 0 01-.12 3.564 8.269 8.269 0 01-1.914 2.84c-.753.843-1.532 1.714-1.532 2.424s.779 1.58 1.532 2.411A8.702 8.702 0 018.979 26.5a8.897 8.897 0 01.106 3.55 4.794 4.794 0 00.145 2.76c.383.549 1.493.776 2.576 1.017 1.16.159 2.275.56 3.275 1.18a8.706 8.706 0 012.1 2.772c.554.978 1.122 1.996 1.756 2.197a4.52 4.52 0 002.641-.71 6.338 6.338 0 013.42-1.004 6.34 6.34 0 013.421 1.004 4.65 4.65 0 002.641.71c.634-.2 1.201-1.219 1.756-2.197a8.707 8.707 0 012.1-2.773c1-.618 2.115-1.02 3.275-1.179 1.083-.24 2.193-.468 2.642-1.004.317-.89.368-1.855.145-2.773a8.897 8.897 0 01.105-3.55 8.7 8.7 0 011.928-2.853c.753-.831 1.533-1.702 1.533-2.412s-.78-1.58-1.532-2.425a8.498 8.498 0 01-1.928-2.84 8.979 8.979 0 01-.106-3.563 4.792 4.792 0 00-.145-2.76c-.383-.535-1.493-.777-2.562-1.004a6.088 6.088 0 01-3.281-1.2 6.221 6.221 0 01-2.108-2.819c-.554-.978-1.122-1.983-1.756-2.197a4.624 4.624 0 00-2.641.71 6.338 6.338 0 01-3.42 1.004 6.34 6.34 0 01-3.421-1.004 6.647 6.647 0 00-2.35-.656l-.014-.094z"
        fill="#fff"
      />
      <path
        d="M24.988 34.536a12.97 12.97 0 01-7.283-2.234 13.249 13.249 0 01-4.83-5.963 13.466 13.466 0 01-.749-7.68 13.35 13.35 0 013.586-6.808 13.043 13.043 0 016.71-3.638 12.927 12.927 0 017.572.76 13.143 13.143 0 015.88 4.9 13.426 13.426 0 012.201 7.388 13.385 13.385 0 01-3.836 9.383 13.007 13.007 0 01-9.25 3.892zm0-24.019c-2.089 0-4.132.629-5.87 1.806a10.685 10.685 0 00-3.89 4.81 10.86 10.86 0 00-.601 6.192 10.766 10.766 0 002.891 5.487 10.517 10.517 0 005.409 2.933c2.05.413 4.174.201 6.105-.61a10.599 10.599 0 004.741-3.947 10.827 10.827 0 001.78-5.954 10.795 10.795 0 00-3.099-7.57 10.49 10.49 0 00-7.466-3.133v-.014z"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M24.312 25.588a1.311 1.311 0 01-.884-.376l-3.513-3.563a1.283 1.283 0 01.062-1.733 1.244 1.244 0 011.708-.063l2.64 2.68 5.52-5.613a1.305 1.305 0 011.548.24 1.356 1.356 0 01.235 1.57l-6.418 6.496c-.243.231-.564.36-.898.362z"
        fill={theme.palette.secondary.main}
      />
    </svg>
  );
}

export function MyProfileIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();

  const width = props.width || 30;
  const height = props.height || 30;

  const color = props.color || theme.palette.text.primary;

  return (
    <svg width={width} height={height} viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8 6.59692C13.8 9.24639 11.6512 11.3938 9 11.3938C6.3488 11.3938 4.2 9.24639 4.2 6.59692C4.2 3.94745 6.3488 1.80005 9 1.80005C11.6512 1.80005 13.8 3.94745 13.8 6.59692Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 24.1855H1C1 23.0494 1 21.9686 1 20.9899C1 18.3389 3.14903 16.1907 5.8 16.1907H12.2C14.851 16.1907 17 18.3389 17 20.9899C17 21.9686 17 23.0494 17 24.1855Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function MessagesIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 20;
  const height = props.height || 20;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.267 12h1.466m-5.866 0h1.466m7.334 0h1.466m5.134 10.267H12C6.33 22.267 1.733 17.67 1.733 12 1.733 6.33 6.33 1.733 12 1.733c5.67 0 10.267 4.597 10.267 10.267v10.267z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function DangerIcon(props: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();
  const width = props.width || 30;
  const height = props.height || 30;

  const color = props.color || theme.palette.text.primary;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.5 4.267a.5.5 0 10-1 0h1zm-1 4.266a.5.5 0 101 0h-1zm1 2.667a.5.5 0 10-1 0h1zm-1 .01a.5.5 0 101 0h-1zm0-6.943v4.266h1V4.267h-1zm0 6.933v.01h1v-.01h-1zm.5 3.767A6.967 6.967 0 011.033 8h-1c0 4.4 3.567 7.966 7.967 7.966v-1zM14.966 8A6.967 6.967 0 018 14.966v1c4.4 0 7.966-3.566 7.966-7.966h-1zM8 1.033A6.967 6.967 0 0114.966 8h1C15.966 3.6 12.4.033 8 .033v1zm0-1A7.967 7.967 0 00.033 8h1A6.967 6.967 0 018 1.033v-1z"
        fill={color}
      />
    </svg>
  );
}
